import { colors } from './colors';

/**
 * A code syntax highlighting theme for use with Shiki: https://shiki.style/guide/load-theme
 */
export const light = {
    colors: {
        'activityBar.background': colors.zinc[50],
        'activityBar.border': colors.zinc[100],
        'activityBar.foreground': colors.slate[600],
        'activityBar.inactiveForeground': colors.slate[400],
        'activityBarBadge.background': colors.blue[600],
        'activityBarBadge.foreground': colors.white,
        'activityBarTop.foreground': colors.slate[600],
        'activityBarTop.inactiveForeground': colors.slate[400],
        'badge.background': `${colors.blue[600]}20`,
        'badge.foreground': colors.slate[700],
        'breadcrumb.activeSelectionForeground': colors.slate[800],
        'breadcrumb.background': colors.zinc[50],
        'breadcrumb.focusForeground': colors.slate[800],
        'breadcrumb.foreground': colors.slate[500],
        'breadcrumbPicker.background': colors.zinc[100],
        'button.background': `${colors.blue[600]}dd`,
        'button.foreground': colors.white,
        'button.hoverBackground': `${colors.blue[600]}aa`,
        'button.secondaryBackground': colors.slate[300],
        'charts.blue': colors.blue[500],
        'charts.foreground': colors.slate[600],
        'charts.green': colors.cyan[600],
        'charts.lines': colors.zinc[200],
        'charts.orange': colors.orange[500],
        'charts.purple': colors.purple[500],
        'charts.red': colors.red[500],
        'charts.yellow': colors.yellow[500],
        'chat.avatarBackground': colors.blue[600],
        'chat.avatarForeground': colors.slate[100],
        'chat.requestBorder': colors.zinc[200],
        'chat.slashCommandBackground': colors.zinc[100],
        'chat.slashCommandForeground': colors.blue[600],
        'debugConsole.errorForeground': colors.red[500],
        'debugConsole.infoForeground': colors.slate[600],
        'debugConsole.sourceForeground': colors.slate[600],
        'debugConsole.warningForeground': colors.yellow[600],
        'debugConsoleInputIcon.foreground': colors.green[600],
        'debugExceptionWidget.background': colors.zinc[100],
        'debugExceptionWidget.border': colors.red[400],
        'debugIcon.breakpointDisabledForeground': colors.slate[400],
        'debugIcon.breakpointForeground': colors.red[500],
        'debugIcon.breakpointUnverifiedForeground': colors.red[400],
        'debugTokenExpression.boolean': colors.yellow[600],
        'debugTokenExpression.error': colors.red[500],
        'debugTokenExpression.name': colors.cyan[600],
        'debugTokenExpression.number': colors.yellow[600],
        'debugTokenExpression.string': colors.green[600],
        'debugTokenExpression.value': colors.slate[600],
        'debugToolBar.background': colors.zinc[100],
        'debugView.stateLabelBackground': colors.zinc[100],
        'debugView.stateLabelForeground': colors.slate[600],
        'debugView.valueChangedHighlight': `${colors.blue[600]}aa`,
        descriptionForeground: colors.slate[500],
        'diffEditor.diagonalFill': colors.slate[300],
        'diffEditor.insertedLineBackground': `${colors.green[600]}25`,
        'diffEditor.insertedTextBackground': `${colors.green[600]}20`,
        'diffEditor.removedLineBackground': `${colors.red[600]}22`,
        'diffEditor.removedTextBackground': `${colors.red[600]}20`,
        'diffEditor.unchangedCodeBackground': `${colors.slate[200]}40`,
        'diffEditorGutter.insertedLineBackground': `${colors.green[600]}25`,
        'diffEditorGutter.removedLineBackground': `${colors.red[600]}22`,
        'diffEditorOverview.insertedForeground': `${colors.green[600]}25`,
        'diffEditorOverview.removedForeground': `${colors.red[600]}22`,
        disabledForeground: colors.slate[400],
        'dropdown.background': colors.zinc[100],
        'dropdown.foreground': colors.slate[700],
        'dropdown.listBackground': colors.zinc[100],
        'editor.background': colors.zinc[50],
        'editor.findMatchBackground': `${colors.blue[600]}40`,
        'editor.findMatchBorder': colors.yellow[500],
        'editor.findMatchHighlightBackground': `${colors.blue[600]}40`,
        'editor.findRangeHighlightBackground': `${colors.slate[400]}33`,
        'editor.focusedStackFrameHighlightBackground': `${colors.green[600]}20`,
        'editor.foldBackground': `${colors.slate[900]}4a`,
        'editor.foreground': colors.slate[800],
        'editor.inactiveSelectionBackground': `${colors.slate[400]}25`,
        'editor.rangeHighlightBackground': `${colors.slate[400]}20`,
        'editor.selectionBackground': `${colors.slate[400]}40`,
        'editor.selectionHighlightBackground': `${colors.slate[400]}40`,
        'editor.stackFrameHighlightBackground': `${colors.yellow[500]}20`,
        'editor.wordHighlightBackground': `${colors.slate[400]}44`,
        'editor.wordHighlightStrongBackground': `${colors.slate[400]}55`,
        'editorBracketHighlight.foreground1': colors.blue[600],
        'editorBracketHighlight.foreground2': colors.cyan[600],
        'editorBracketHighlight.foreground3': colors.purple[600],
        'editorBracketHighlight.foreground4': colors.cyan[700],
        'editorBracketHighlight.foreground5': colors.green[600],
        'editorBracketHighlight.foreground6': colors.yellow[600],
        'editorBracketHighlight.unexpectedBracket.foreground': colors.red[600],
        'editorBracketMatch.background': colors.zinc[100],
        'editorBracketMatch.border': colors.slate[400],
        'editorBracketPairGuide.activeBackground1': colors.blue[500],
        'editorBracketPairGuide.activeBackground2': colors.cyan[500],
        'editorBracketPairGuide.activeBackground3': colors.purple[500],
        'editorBracketPairGuide.activeBackground4': colors.cyan[600],
        'editorBracketPairGuide.activeBackground5': colors.green[500],
        'editorBracketPairGuide.activeBackground6': colors.yellow[500],
        'editorCodeLens.foreground': colors.slate[500],
        'editorCursor.foreground': colors.slate[800],
        'editorError.foreground': colors.red[600],
        'editorGhostText.foreground': colors.slate[400],
        'editorGroup.border': colors.zinc[200],
        'editorGroup.dropBackground': colors.slate[200],
        'editorGroupHeader.border': colors.zinc[200],
        'editorGroupHeader.noTabsBackground': colors.zinc[100],
        'editorGroupHeader.tabsBackground': colors.zinc[100],
        'editorGroupHeader.tabsBorder': colors.zinc[200],
        'editorGutter.addedBackground': colors.green[700],
        'editorGutter.deletedBackground': colors.red[700],
        'editorGutter.modifiedBackground': colors.blue[700],
        'editorHint.foreground': colors.cyan[600],
        'editorHoverWidget.background': colors.zinc[100],
        'editorHoverWidget.border': colors.zinc[200],
        'editorIndentGuide.activeBackground1': colors.slate[400],
        'editorIndentGuide.background1': colors.slate[300],
        'editorInfo.foreground': colors.cyan[600],
        'editorInlayHint.foreground': colors.slate[400],
        'editorLightBulb.foreground': colors.yellow[500],
        'editorLightBulbAutoFix.foreground': colors.yellow[500],
        'editorLineNumber.foreground': colors.slate[400],
        'editorLineNumber.activeForeground': colors.slate[800],
        'editorLink.activeForeground': colors.slate[600],
        'editorMarkerNavigation.background': colors.zinc[100],
        'editorOverviewRuler.addedForeground': colors.green[600],
        'editorOverviewRuler.border': colors.zinc[200],
        'editorOverviewRuler.bracketMatchForeground': colors.zinc[200],
        'editorOverviewRuler.deletedForeground': colors.red[600],
        'editorOverviewRuler.errorForeground': colors.red[500],
        'editorOverviewRuler.findMatchForeground': `${colors.slate[600]}44`,
        'editorOverviewRuler.infoForeground': colors.cyan[600],
        'editorOverviewRuler.modifiedForeground': colors.blue[600],
        'editorOverviewRuler.rangeHighlightForeground': `${colors.slate[600]}44`,
        'editorOverviewRuler.selectionHighlightForeground': `${colors.slate[600]}22`,
        'editorOverviewRuler.warningForeground': colors.yellow[500],
        'editorOverviewRuler.wordHighlightForeground': `${colors.purple[600]}55`,
        'editorOverviewRuler.wordHighlightStrongForeground': `${colors.purple[600]}66`,
        'editorPane.background': colors.zinc[50],
        'editorRuler.foreground': colors.zinc[200],
        'editorSuggestWidget.background': colors.zinc[100],
        'editorSuggestWidget.border': colors.zinc[200],
        'editorSuggestWidget.highlightForeground': colors.blue[600],
        'editorSuggestWidget.selectedBackground': colors.slate[200],
        'editorWarning.foreground': colors.yellow[600],
        'editorWhitespace.foreground': colors.slate[400],
        'editorWidget.background': colors.zinc[100],
        'editorWidget.border': colors.zinc[200],
        'editorWidget.foreground': colors.slate[600],
        'editorWidget.resizeBorder': `${colors.slate[400]}33`,
        errorForeground: colors.slate[500],
        'extensionBadge.remoteBackground': colors.blue[600],
        'extensionBadge.remoteForeground': colors.white,
        'extensionButton.prominentBackground': `${colors.blue[600]}dd`,
        'extensionButton.prominentForeground': colors.white,
        'extensionButton.prominentHoverBackground': `${colors.blue[600]}aa`,
        focusBorder: `${colors.slate[400]}33`,
        foreground: colors.slate[600],
        'gitDecoration.addedResourceForeground': colors.cyan[600],
        'gitDecoration.conflictingResourceForeground': `${colors.yellow[600]}cc`,
        'gitDecoration.deletedResourceForeground': colors.red[600],
        'gitDecoration.ignoredResourceForeground': colors.slate[400],
        'gitDecoration.modifiedResourceForeground': colors.blue[600],
        'gitDecoration.renamedResourceForeground': colors.cyan[600],
        'gitDecoration.stageDeletedResourceForeground': colors.red[500],
        'gitDecoration.stageModifiedResourceForeground': colors.blue[500],
        'gitDecoration.untrackedResourceForeground': colors.cyan[600],
        'gitlens.gutterBackgroundColor': colors.zinc[100],
        'gitlens.gutterForegroundColor': colors.slate[600],
        'gitlens.gutterUncommittedForegroundColor': colors.blue[600],
        'gitlens.trailingLineForegroundColor': colors.slate[400],
        'icon.foreground': colors.slate[600],
        'inlineChat.foreground': colors.slate[800],
        'inlineChatDiff.inserted': `${colors.cyan[600]}40`,
        'inlineChatDiff.removed': `${colors.red[600]}40`,
        'inlineChatInput.background': colors.zinc[100],
        'input.background': colors.zinc[100],
        'input.border': colors.zinc[200],
        'input.foreground': colors.slate[800],
        'input.placeholderForeground': `${colors.slate[600]}8A`,
        'inputOption.activeBackground': `${colors.blue[600]}44`,
        'inputOption.activeForeground': colors.slate[800],
        'inputValidation.errorBackground': colors.red[100],
        'inputValidation.errorBorder': colors.red[400],
        'inputValidation.errorForeground': colors.slate[800],
        'inputValidation.infoBackground': `${colors.blue[600]}20`,
        'inputValidation.infoBorder': colors.blue[600],
        'inputValidation.infoForeground': colors.slate[800],
        'inputValidation.warningBackground': colors.yellow[100],
        'inputValidation.warningBorder': colors.yellow[500],
        'inputValidation.warningForeground': colors.slate[900],
        'list.activeSelectionBackground': colors.slate[200],
        'list.activeSelectionForeground': colors.slate[900],
        'list.deemphasizedForeground': colors.slate[500],
        'list.dropBackground': colors.slate[200],
        'list.errorForeground': colors.red[500],
        'list.focusBackground': colors.slate[200],
        'list.focusForeground': colors.slate[900],
        'list.highlightForeground': colors.blue[600],
        'list.hoverBackground': colors.slate[100],
        'list.hoverForeground': colors.slate[900],
        'list.inactiveSelectionBackground': colors.slate[200],
        'list.inactiveSelectionForeground': colors.slate[800],
        'list.invalidItemForeground': colors.orange[600],
        'list.warningForeground': colors.yellow[600],
        'listFilterWidget.background': colors.zinc[100],
        'listFilterWidget.noMatchesOutline': colors.red[400],
        'listFilterWidget.outline': colors.blue[600],
        'menu.background': colors.zinc[50],
        'menu.border': colors.zinc[200],
        'menu.foreground': colors.slate[600],
        'menu.selectionBackground': colors.slate[200],
        'menu.selectionForeground': colors.slate[900],
        'menu.separatorBackground': colors.zinc[200],
        'menubar.selectionBackground': colors.slate[200],
        'menubar.selectionBorder': colors.slate[300],
        'menubar.selectionForeground': colors.slate[800],
        'merge.currentContentBackground': `${colors.green[600]}20`,
        'merge.currentHeaderBackground': `${colors.green[600]}40`,
        'merge.incomingContentBackground': `${colors.blue[600]}20`,
        'merge.incomingHeaderBackground': `${colors.blue[600]}40`,
        'mergeEditor.change.background': `${colors.cyan[600]}25`,
        'mergeEditor.change.word.background': `${colors.cyan[600]}40`,
        'mergeEditor.conflict.handled.minimapOverViewRuler': colors.cyan[600],
        'mergeEditor.conflict.handledFocused.border': `${colors.cyan[600]}65`,
        'mergeEditor.conflict.handledUnfocused.border': `${colors.cyan[600]}25`,
        'mergeEditor.conflict.unhandled.minimapOverViewRuler':
            colors.yellow[500],
        'mergeEditor.conflict.unhandledFocused.border': `${colors.yellow[500]}b0`,
        'mergeEditor.conflict.unhandledUnfocused.border': `${colors.yellow[500]}88`,
        'minimapGutter.addedBackground': colors.green[600],
        'minimapGutter.deletedBackground': colors.red[600],
        'minimapGutter.modifiedBackground': colors.blue[600],
        'multiDiffEditor.border': colors.zinc[200],
        'multiDiffEditor.headerBackground': colors.zinc[100],
        'notebook.cellBorderColor': colors.zinc[200],
        'notebook.cellEditorBackground': colors.zinc[100],
        'notebook.cellStatusBarItemHoverBackground': colors.slate[200],
        'notebook.editorBackground': colors.zinc[50],
        'notebook.focusedCellBorder': colors.blue[400],
        'notificationCenterHeader.background': colors.zinc[200],
        'notificationLink.foreground': colors.blue[600],
        'notifications.background': colors.zinc[100],
        'notificationsErrorIcon.foreground': colors.red[500],
        'notificationsInfoIcon.foreground': colors.cyan[600],
        'notificationsWarningIcon.foreground': colors.yellow[600],
        'panel.background': colors.zinc[50],
        'panel.border': colors.zinc[200],
        'panelInput.border': colors.zinc[100],
        'panelTitle.activeBorder': colors.zinc[100],
        'panelTitle.activeForeground': colors.slate[600],
        'panelTitle.inactiveForeground': colors.slate[400],
        'peekView.border': colors.zinc[200],
        'peekViewEditor.background': colors.zinc[100],
        'peekViewEditor.matchHighlightBackground': `${colors.blue[600]}40`,
        'peekViewResult.background': colors.zinc[50],
        'peekViewResult.fileForeground': colors.slate[600],
        'peekViewResult.lineForeground': colors.slate[800],
        'peekViewResult.matchHighlightBackground': `${colors.blue[600]}40`,
        'peekViewResult.selectionBackground': `${colors.blue[600]}20`,
        'peekViewResult.selectionForeground': colors.slate[900],
        'peekViewTitle.background': colors.zinc[100],
        'peekViewTitleDescription.foreground': colors.slate[600],
        'peekViewTitleLabel.foreground': colors.slate[900],
        'pickerGroup.border': colors.zinc[200],
        'pickerGroup.foreground': colors.slate[800],
        'progressBar.background': colors.blue[600],
        'sash.hoverBorder': colors.blue[400],
        'scmGraph.foreground1': colors.orange[500],
        'scmGraph.foreground2': colors.yellow[600],
        'scmGraph.foreground3': colors.cyan[600],
        'scmGraph.foreground4': colors.blue[600],
        'scmGraph.foreground5': colors.purple[600],
        'scmGraph.historyItemBaseRefColor': colors.purple[500],
        'scmGraph.historyItemHoverAdditionsForeground': colors.cyan[600],
        'scmGraph.historyItemHoverDefaultLabelForeground': colors.slate[800],
        'scmGraph.historyItemHoverDeletionsForeground': colors.red[500],
        'scmGraph.historyItemHoverLabelForeground': colors.slate[900],
        'scmGraph.historyItemRefColor': colors.blue[600],
        'scmGraph.historyItemRemoteRefColor': colors.cyan[600],
        'scrollbar.shadow': `${colors.slate[900]}10`,
        'scrollbarSlider.activeBackground': `${colors.slate[400]}30`,
        'scrollbarSlider.background': `${colors.slate[400]}20`,
        'scrollbarSlider.hoverBackground': `${colors.slate[400]}25`,
        'selection.background': `${colors.slate[400]}40`,
        'settings.headerForeground': colors.blue[600],
        'sideBar.background': colors.zinc[50],
        'sideBar.border': colors.zinc[200],
        'sideBar.dropBackground': colors.slate[200],
        'sideBar.foreground': colors.slate[600],
        'sideBarSectionHeader.background': colors.zinc[100],
        'sideBarSectionHeader.border': colors.zinc[200],
        'sideBarSectionHeader.foreground': colors.slate[800],
        'sideBarTitle.foreground': colors.slate[600],
        'statusBar.background': colors.zinc[50],
        'statusBar.border': colors.zinc[200],
        'statusBar.debuggingBackground': colors.zinc[100],
        'statusBar.debuggingForeground': colors.slate[600],
        'statusBar.foreground': colors.slate[600],
        'statusBar.noFolderBackground': colors.zinc[100],
        'statusBarItem.activeBackground': colors.zinc[200],
        'statusBarItem.hoverBackground': colors.slate[200],
        'statusBarItem.prominentBackground': colors.zinc[200],
        'statusBarItem.prominentHoverBackground': colors.slate[200],
        'tab.activeBackground': colors.zinc[50],
        'tab.activeBorder': colors.blue[600],
        'tab.activeForeground': colors.slate[900],
        'tab.activeModifiedBorder': colors.zinc[200],
        'tab.border': colors.zinc[200],
        'tab.hoverForeground': colors.slate[800],
        'tab.inactiveBackground': colors.zinc[100],
        'tab.inactiveForeground': colors.slate[600],
        'tab.inactiveModifiedBorder': colors.zinc[300],
        'tab.lastPinnedBorder': colors.slate[300],
        'tab.unfocusedActiveBorder': colors.zinc[300],
        'tab.unfocusedActiveForeground': colors.slate[800],
        'tab.unfocusedHoverForeground': colors.slate[800],
        'tab.unfocusedInactiveForeground': colors.slate[600],
        'terminal.foreground': colors.slate[600],
        'terminal.background': colors.zinc[50],
        'terminal.ansiBlack': colors.slate[900],
        'terminal.ansiBlue': colors.blue[600],
        'terminal.ansiBrightBlack': colors.slate[400],
        'terminal.ansiBrightBlue': colors.blue[500],
        'terminal.ansiBrightCyan': colors.cyan[500],
        'terminal.ansiBrightGreen': colors.green[500],
        'terminal.ansiBrightMagenta': colors.purple[500],
        'terminal.ansiBrightRed': colors.red[500],
        'terminal.ansiBrightWhite': colors.slate[200],
        'terminal.ansiBrightYellow': colors.yellow[500],
        'terminal.ansiCyan': colors.cyan[600],
        'terminal.ansiGreen': colors.green[600],
        'terminal.ansiMagenta': colors.purple[600],
        'terminal.ansiRed': colors.red[600],
        'terminal.ansiWhite': colors.slate[200],
        'terminal.ansiYellow': colors.yellow[600],
        'terminal.selectionBackground': `${colors.slate[400]}40`,
        'textBlockQuote.background': colors.zinc[100],
        'textCodeBlock.background': colors.zinc[100],
        'textLink.activeForeground': colors.blue[700],
        'textLink.foreground': colors.blue[600],
        'textPreformat.foreground': colors.slate[600],
        'textSeparator.foreground': colors.slate[400],
        'titleBar.activeBackground': colors.zinc[50],
        'titleBar.activeForeground': colors.slate[600],
        'titleBar.border': colors.zinc[200],
        'titleBar.inactiveBackground': colors.zinc[100],
        'titleBar.inactiveForeground': colors.slate[500],
        'toolbar.activeBackground': colors.slate[200],
        'toolbar.hoverBackground': colors.slate[200],
        'tree.indentGuidesStroke': colors.slate[300],
        'walkThrough.embeddedEditorBackground': colors.zinc[100],
        'widget.shadow': `${colors.slate[900]}10`,
        'window.activeBorder': colors.zinc[300],
        'window.inactiveBorder': colors.zinc[300],
        'editor.lineHighlightBackground': `${colors.slate[400]}20`,
        'keyword.control': colors.purple[700],
        'string.quoted': colors.green[700],
        'constant.numeric': colors.yellow[800],
        'variable.other': colors.slate[800],
        'entity.name.function': colors.blue[600],
        'support.function': colors.cyan[700],
        comment: colors.slate[500],
        'editorGutter.background': colors.zinc[50],
    },
    displayName: 'Light',
    name: 'light',
    semanticTokenColors: {
        '*.defaultLibrary': {
            foreground: colors.cyan[700],
        },
        parameter: {
            foreground: colors.slate[800],
        },
        'parameter.declaration': {
            foreground: colors.yellow[800],
        },
        'property.declaration': {
            foreground: colors.green[700],
        },
        'property.defaultLibrary': {
            foreground: colors.cyan[700],
        },
        variable: {
            foreground: colors.slate[800],
        },
        'variable.declaration': {
            foreground: colors.purple[700],
        },
        'variable.defaultLibrary': {
            foreground: colors.cyan[700],
        },
    },
    tokenColors: [
        {
            scope: [
                'comment',
                'meta.var.expr storage.type',
                'keyword.control.flow',
                'keyword.control.return',
                'meta.directive.vue punctuation.separator.key-value.html',
                'meta.directive.vue entity.other.attribute-name.html',
                'tag.decorator.js entity.name.tag.js',
                'tag.decorator.js punctuation.definition.tag.js',
                'storage.modifier',
                'string.quoted.docstring.multi',
                'string.quoted.docstring.multi.python punctuation.definition.string.begin',
                'string.quoted.docstring.multi.python punctuation.definition.string.end',
                'string.quoted.docstring.multi.python constant.character.escape',
            ],
            settings: {
                fontStyle: 'italic',
            },
        },
        {
            scope: [
                'keyword.control.flow.block-scalar.literal',
                'keyword.control.flow.python',
            ],
            settings: {
                fontStyle: '',
            },
        },
        {
            scope: [
                'comment',
                'comment.block.documentation',
                'punctuation.definition.comment',
                'string.quoted.docstring.multi',
            ],
            settings: {
                foreground: colors.slate[500],
                fontStyle: 'italic',
            },
        },
        {
            scope: [
                'constant.language',
                'constant.numeric',
                'constant.other.caps',
                'variable.other.constant',
            ],
            settings: {
                foreground: colors.yellow[800],
            },
        },
        {
            scope: [
                'string',
                'string.quoted',
                'constant.other.symbol',
                'constant.other.key',
            ],
            settings: {
                foreground: colors.green[700],
                fontStyle: '',
            },
        },
        {
            scope: [
                'keyword',
                'keyword.control',
                'keyword.operator.logical',
                'storage.type',
                'storage.modifier',
            ],
            settings: {
                foreground: colors.purple[700],
            },
        },
        {
            scope: [
                'entity.name.function',
                'support.function',
                'meta.function-call',
            ],
            settings: {
                foreground: colors.blue[600],
            },
        },
        {
            scope: [
                'support.class',
                'entity.name.type',
                'entity.other.inherited-class',
            ],
            settings: {
                foreground: colors.cyan[700],
            },
        },
        {
            scope: ['variable', 'variable.other', 'variable.language'],
            settings: {
                foreground: colors.slate[800],
            },
        },
        {
            scope: [
                'entity.name.tag',
                'entity.name.tag support.class.component',
            ],
            settings: {
                foreground: colors.red[600],
            },
        },
        {
            scope: [
                'entity.other.attribute-name',
                'entity.other.attribute-name.class',
            ],
            settings: {
                foreground: colors.purple[600],
            },
        },
        {
            scope: ['markup.heading', 'markup.bold', 'markup.italic'],
            settings: {
                foreground: colors.slate[900],
            },
        },
        {
            scope: ['markup.underline.link', 'string.other.link'],
            settings: {
                foreground: colors.blue[600],
            },
        },
        {
            scope: ['invalid', 'invalid.illegal'],
            settings: {
                foreground: colors.red[500],
            },
        },
        {
            scope: ['string.regexp'],
            settings: {
                foreground: colors.green[700],
            },
        },
        {
            scope: [
                'support.type.property-name',
                'support.type.vendored.property-name',
            ],
            settings: {
                foreground: colors.blue[600],
            },
        },
        {
            scope: ['support.constant.property-value'],
            settings: {
                foreground: colors.yellow[800],
            },
        },
    ],
    type: 'light',
};
